import React, { useState } from 'react'
import { M_Membresias } from './M_Membresias'
import { Edit, PlusCircle, RefreshCcw, Trash2 } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux';
import { Table_2 } from '../../../utils/Table_2';
import { startActivateMembresia, startDeleteMembresia } from '../../../../app/store/catalagos/thunks';
import Swal from 'sweetalert2';

export const Membresias = () => {

    const dispatch = useDispatch();
    const { status, membresias, isLoading } = useSelector(state => state.catalogos);
    const [selectedMembresia, setSelectedMembresia] = useState(null);

    const dataU = [...membresias];
    const columnsType = [
        {
            header: 'ID',
            dataIndex: 'ID',
            classHeader: 'text-center',
            classRow: 'text-center fw-bold ',
        },
        {
            header: 'NOMBRE',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start fw-bold ',
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPCION',
            classHeader: 'text-start',
            classRow: 'text-start fw-bold ',
        },
        {
            header: 'COSTO',
            dataIndex: 'COSTO',
            classHeader: 'text-center',
            classRow: 'text-center fw-bold ',
            renderer: (value) => (Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)),
        },
        {
            header: 'DURACION (DIAS)',
            dataIndex: 'DURACION',
            classHeader: 'text-center',
            classRow: 'text-center fw-bold ',
        },
        {
            header: 'ESTADO',
            dataIndex: 'ESTADO',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (

                (value == 1) ?
                    <><span className="status-btn complete-btn"> ACTIVO </span> </>
                    :
                    <> <span className="status-btn pending-btn"> ELIMINADO </span></>
            ),
        },
        {
            header: 'ACCIONES',
            dataIndex: 'ESTADO',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <div className="btn-group border-0" role="group" >


                    <button type="button" className="btn btn-outline-primary border-0" data-bs-toggle="modal" data-bs-target="#membresia"  onClick={() => setSelectedMembresia(row)}
                    // onClick={e => handledEditCliente(row.ID)}
                    >
                        <Edit size="20" />
                    </button>
                    {
                        row.ESTADO == 1 ?
                            <>
                                <button type="button" className="btn btn-outline-danger border-0" onClick={e => handledDelete(row.ID)}>
                                    <Trash2 size="20" />
                                </button>
                            </>
                            :
                            <>
                                <button type="button" className="btn btn-outline-success border-0" onClick={e => handledActive(row.ID)}>
                                    <RefreshCcw size="20" />
                                </button>
                            </>
                    }
                </div>
            )
        },

    ];

    const handledDelete = (id) => {
        Swal.fire({
            title: 'Atención',
            text: "Está por desactivar una membresia, ¿Desea de continuar con esta acción?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b7ddd',
            cancelButtonColor: '#dc3545',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(startDeleteMembresia(id));
            } 
        })
    }

    const handledActive = (id) => {

        Swal.fire({
            title: 'Atención',
            text: "Está por activar una membresia, ¿Desea de continuar con esta acción?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b7ddd',
            cancelButtonColor: '#dc3545',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(startActivateMembresia(id));
            } 
        })
    }

    return (
        <>
            <M_Membresias selectedMembresia={selectedMembresia} setSelectedMembresia={setSelectedMembresia} />
            <div className="p-1">
                <div className="card-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom mb-3">
                    <h4 className="card-title text-black fw-bold mb-2">Membresias</h4>
                    <button type="button" className="btn btn-outline-primary mb-2" data-bs-toggle="modal" data-bs-target="#membresia" onClick={() => setSelectedMembresia(null)}>
                        <PlusCircle size={20} />  Agregar Nuevo
                    </button>
                </div>
                <div className="card-body">
                    <Table_2 typeTable={4} columns={columnsType} data={dataU} msg={'En espera para mostrar datos'} />
                </div>
            </div>
        </>
    )
}
